import { useDispatch } from 'react-redux';
import { logout } from '../store/authSlice';
import { useNavigate, Link } from 'react-router-dom';

const Sidebar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
  };

  return (
    <div className="w-64 bg-gray-800 text-white h-screen flex flex-col justify-between p-6">
      <div>
        {/* Logo */}
        <div className="text-center mb-8">
  <img
    src="/monkeybox_logo.png"
    alt="Logo"
    className="mx-auto h-16 w-auto"
  />
</div>
        {/* Menu Sections */}
        <div className="space-y-6">
          {/* User Management */}

          <div>
          
            <ul className="space-y-2">
            <li>
                  <Link
                    to="/home"
                    className="block hover:bg-gray-700 p-2 rounded"
                  >
                    Home
                  </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm text-gray-400 uppercase tracking-wider mb-2">Admin</h3>
            <ul className="space-y-2">
            <Link
                        to="/plantype/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Plan Type
                      </Link>


                      <Link
                        to="/plandetail/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Create New Plan
                      </Link>
         
            </ul>
          </div>

          {/* Logistics */}
          <div>
            <h3 className="text-sm text-gray-400 uppercase tracking-wider mb-2">Logistics</h3>
            <ul className="space-y-2">
            <Link
  to="/deliveryroute/new"
  className="block hover:bg-gray-700 p-2 rounded"
>
  Route
</Link>
              <Link
  to="/schools/new"
  className="block hover:bg-gray-700 p-2 rounded"
>
  School
</Link>
        <Link
            to="/pods/new"
            className="block hover:bg-gray-700 p-2 rounded"
          >
            Pod
        </Link>
                      <Link
                        to="/addresses/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Addresses
                      </Link>

            </ul>
          </div>

          {/* Menu Management */}
          <div>
            <h3 className="text-sm text-gray-400 uppercase tracking-wider mb-2">Menu Management</h3>
            <ul className="space-y-2">


                      <Link
                        to="/mealtype/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Meal Types
                      </Link>
             
             
             
                      <Link
                        to="/menu/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Menu Item
                      </Link>
              
                      <Link
                        to="/subitem/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Sub Item
                      </Link>
                      <Link
                        to="/weeklymenu/new"
                        className="block hover:bg-gray-700 p-2 rounded"
                      >
                        Weekly Menu
                      </Link>

                      <Link
                          to="/planholidays/new"
                          className="block hover:bg-gray-700 p-2 rounded"
                        >
                          Plan Holidays
                        </Link>
            </ul>
          </div>
        </div>
      </div>

      {/* Logout Button */}
      <div className="pt-6 border-t border-gray-700">
        <button
          onClick={handleLogout}
          className="w-full text-left text-red-400 hover:text-white hover:bg-red-600 p-2 rounded"
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
